// History-API router. Routes are the SPA's own paths (see shared/spa-routes.js);
// anything else on the host belongs to the backend, so the router only ever
// navigates within that set and never intercepts links to backend URLs.

const routes = [];
let notFound = null;

export function route(pattern, handler) {
  // pattern: exact string, or RegExp with capture groups passed to handler
  routes.push({ pattern, handler });
}

export function otherwise(handler) {
  notFound = handler;
}

export function currentPath() {
  return window.location.pathname;
}

export function dispatch() {
  const path = currentPath();
  for (const r of routes) {
    if (typeof r.pattern === 'string') {
      if (r.pattern === path) return r.handler({ path });
    } else {
      const m = path.match(r.pattern);
      if (m) return r.handler({ path, params: m.slice(1) });
    }
  }
  if (notFound) return notFound({ path });
  return undefined;
}

export function navigate(path, { replace = false } = {}) {
  if (path === currentPath()) return dispatch();
  if (replace) history.replaceState(null, '', path);
  else history.pushState(null, '', path);
  return dispatch();
}

export function start() {
  window.addEventListener('popstate', () => dispatch());
  // Links marked data-route navigate client-side; plain links behave normally.
  document.addEventListener('click', (e) => {
    const a = e.target.closest && e.target.closest('a[data-route]');
    if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey) return;
    e.preventDefault();
    navigate(a.getAttribute('href'));
  });
  return dispatch();
}
